/* eslint-disable max-lines */
export const config = {
    searchList: {
        // fieldTrim 为 true 时 对查询条件字段值进行 trim 而不是 替换空白字符
        fieldTrim: true,
        searchTxt: [
            {
                name: '批量选择',
                value: 'batchQueryValue',
                type: 'input',
                placeholder: '最多查询100单，以逗号隔开',
                selectConfig: {
                    width: '85px',
                    prop: 'batchQueryKey',
                    value: 'dispatchNoList',
                    option: [
                        { label: '发车单号', prop: 'dispatchNoList', placeholder: '最多查询100单，以逗号隔开' },
                        { label: '运输单号', prop: 'taskNoList', placeholder: '最多查询100单，以逗号隔开' },
                        { label: '网络调车单号', prop: 'netDispatchNoList', placeholder: '最多查询100单，以逗号隔开' },
                        { label: '物流订单号', prop: 'orderNoList', placeholder: '最多查询100单，以逗号隔开' },
                        { label: '发货单号', prop: 'dispatchNoMappingList', placeholder: '最多查询100单，以逗号隔开' },
                        { label: '合同编号', prop: 'contractNoList', placeholder: '最多查询100单，以逗号隔开' }
                    ]
                },
                unfold: true,
                span: 5
            },
            {
                name: '客户订单号',
                value: 'custOrderNo',
                type: 'input',
                unfold: true,
                fieldTrim: true,
                placeholder: '客户订单号(最多查询100单，以逗号隔开)',
                span: 4
            },
            {
                name: '发车单状态',
                value: 'dispatchStatus',
                type: 'select',
                unfold: true,
                filterable: true,
                multiple: true,
                optionNum: 'DISPATCH_STATUS',
                options: [],
                span: 4
            },
            {
                name: '创建时间',
                value: 'createTime',
                startTime: 'startCreateTime',
                endTime: 'endCreateTime',
                startPlaceholder: '创建开始日期',
                endPlaceholder: '创建结束日期',
                type: 'time',
                timeNum: 2,
                unfold: true,
                span: 5
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        hasMaxBtnNum: true,
        maxBtnNum: 3,
        clickState: false,
        selectBtn: true,
        height: 400,
        columns: [
            {
                label: '序号',
                prop: 'id',
                sort: true,
                width: 150
            },
            {
                label: '预约装货状态',
                prop: 'appointmentStatus',
                sort: true,
                type: 'select',
                optionNum: '',
                options: [
                    { label: '不用预约', value: '0' },
                    { label: '待预约', value: '1' },
                    { label: '已预约', value: '2' }
                ],
                width: 140
            },
            {
                label: '装货预约加急',
                prop: 'urgentStatus',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '是', value: '1' },
                    { label: '否', value: '0' }
                ],
                sort: true,
                width: 150
            },
            {
                label: '发车单号',
                prop: 'dispatchNo',
                sort: true,
                width: 150
            },
            {
                label: '发货单号',
                prop: 'dispatchNoMapping',
                sort: true,
                width: 150
            },
            {
                label: '运费修改日志',
                prop: 'transportLog',
                type: 'button',
                sort: true,
                width: 150
            },
            {
                label: '运输收入(元)',
                prop: 'transportIncome', // 特别注意，该字段有展示权限，修改label、prop时，同步修改hideField
                sort: true,
                width: 150
            },
            {
                label: '毛利率',
                prop: 'grossProfitMargin', // 特别注意，该字段有展示权限，修改label、prop时，同步修改hideField
                sort: true,
                width: 150
            },
            {
                label: '毛利金额',
                prop: 'grossProfit', // 特别注意，该字段有展示权限，修改label、prop时，同步修改hideField
                sort: true,
                width: 150
            },
            {
                label: '目标价-以收定支',
                prop: 'bmsIncomeAfter', // 特别注意，该字段有展示权限，修改label、prop时，同步修改hideField
                sort: true,
                width: 150
            },
            {
                label: '是否计费前置',
                prop: 'billingAdvanceFlag',
                sort: true,
                width: 100,
                type: 'select',
                optionNum: '',
                options: [
                    { value: 'true', label: '是' },
                    { value: 'false', label: '否' }
                ]
            },
            {
                label: '是否试算',
                prop: 'trialCalculateFlag',
                sort: true,
                width: 100,
                type: 'select',
                optionNum: '',
                options: [
                    { value: 'true', label: '是' },
                    { value: 'false', label: '否' }
                ]
            },
            {
                label: '是否存在计费异常',
                prop: 'billingExceptionFlag',
                sort: true,
                width: 100,
                type: 'select',
                optionNum: '',
                options: [
                    { value: 'true', label: '是' },
                    { value: 'false', label: '否' }
                ]
            },
            {
                label: '收入异常TK单数量',
                prop: 'incomeFeeExceptionTkCount',
                sort: true,
                width: 120
            },
            {
                label: '成本异常TK单数量',
                prop: 'costFeeExceptionTkCount',
                sort: true,
                width: 120
            },
            {
                label: '运输方式',
                prop: 'transportTypeName',
                sort: true,
                width: 150
            },
            {
                label: '出入库类型',
                prop: 'inOutTypeName',
                sort: true,
                width: 150
            },
            {
                label: '计费车型',
                prop: 'equipmentName',
                sort: true,
                width: 150
            },
            {
                label: '实际运作车型名称',
                prop: 'equipmentOperateName',
                sort: true,
                width: 150
            },
            {
                label: '实际运作车型编码',
                prop: 'equipmentOperateType',
                sort: true,
                width: 150
            },
            {
                label: '车辆内径长',
                prop: 'interiorLength',
                sort: true,
                width: 150
            },
            {
                label: '车辆内径宽',
                prop: 'interiorWidth',
                sort: true,
                width: 150
            },
            {
                label: '车辆内径高',
                prop: 'interiorHeight',
                sort: true,
                width: 150
            },
            {
                label: '车辆信息',
                prop: 'carInfo',
                sort: true,
                width: 150
            },
            {
                label: '承运商',
                prop: 'carrierName',
                sort: true,
                width: 182
            },
            {
                label: '无车承运商',
                sort: true,
                prop: 'noCarCarrierName',
                width: 120
            },
            {
                label: '车牌号',
                sort: true,
                prop: 'vehicleCard',
                width: 120
            },
            {
                label: '司机名称',
                sort: true,
                prop: 'driver',
                width: 120
            },
            {
                label: '发车单状态',
                sort: true,
                type: 'button',
                prop: 'dispatchStatusName',
                width: 120
            },
            {
                label: '串点数合计',
                sort: true,
                prop: 'pointsNumber',
                width: 120
            },
            {
                label: '串点里程',
                sort: true,
                prop: 'subsidyMileage',
                width: 120
            },
            {
                label: '审批状态',
                prop: 'iflowStatusName',
                sort: true,
                width: 160
            },
            {
                label: '是否发起审批',
                prop: 'isIflowName',
                align: 'center',
                sort: true,
                width: 130
            },
            {
                label: '合同外场景',
                prop: 'contractOutName',
                sort: true,
                width: 160
            },
            {
                label: '发运场景',
                prop: 'shippingSceneType',
                type: 'select',
                optionNum: 'SHIPPING_SCENE_TYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '高端服务发车单',
                prop: 'orderTypeExt',
                type: 'select',
                optionNum: 'DISPATCH_EMERGENCE_FLAG',
                options: [],
                sort: true,
                width: 140
            },
            {
                label: '司机联系方式',
                prop: 'driverContactWay',
                sort: true,
                width: 160
            },
            {
                label: '总里程(km)',
                prop: 'totalMileage',
                sort: true,
                width: 160
            },
            {
                label: '总件数',
                prop: 'totalQty',
                sort: true,
                width: 160
            },
            {
                label: '总毛重(kg)',
                prop: 'totalGrossWeight',
                sort: true,
                width: 160
            },
            {
                label: '总净重(kg)',
                prop: 'totalNetWeight',
                sort: true,
                width: 160
            },
            {
                label: '总体积(m³)',
                prop: 'volume',
                sort: true,
                width: 160
            },
            {
                label: '单量',
                prop: 'taskCount',
                sort: true,
                width: 160
            },
            {
                label: '实扫数量',
                prop: 'rfActLoadQty',
                sort: true,
                width: 160
            },
            {
                label: '实发数量',
                prop: 'loadedEa',
                sort: true,
                width: 160
            },
            {
                label: '实发体积',
                prop: 'loadedVolume',
                sort: true,
                width: 160
            },
            {
                label: '总货值',
                prop: 'totalAmount',
                sort: true,
                width: 160
            },
            {
                label: '采购渠道',
                prop: 'procurementChannelName',
                sort: true,
                width: 160
            },
            {
                label: '设备号',
                prop: 'deviceNo',
                sort: true,
                width: 160
            },
            {
                label: '设备类型',
                prop: 'deviceTypeName',
                sort: true,
                width: 160
            },
            {
                label: '是否绑定设备号',
                prop: 'bindingDeviceFlagName',
                sort: true,
                width: 160
            },
            {
                label: '是否无车平台',
                prop: 'noCarPlatformFlagName',
                sort: true,
                width: 160
            },
            {
                label: '无车平台类型',
                prop: 'noCarCarrierTypeName',
                sort: true,
                width: 160
            },
            {
                label: '装载过低类型',
                prop: 'exceptionTypeName',
                sort: true,
                width: 160
            },
            {
                label: '运输里程(高德)(km)',
                prop: 'amapMileage',
                sort: true,
                width: 160
            },
            {
                label: '装载过低异常备注',
                prop: 'exceptionMark',
                sort: true,
                width: 160
            },
            {
                label: '预计到车时间',
                prop: 'besArriveDate',
                sort: true,
                width: 160
            },
            {
                label: '到车登记时间',
                prop: 'actualArriveDate',
                sort: true,
                width: 160
            },
            {
                label: '装车时间',
                prop: 'loadDate',
                sort: true,
                width: 160
            },
            {
                label: '抵达时间',
                prop: 'arrivalTime',
                sort: true,
                width: 160
            },
            {
                label: '月度目标成本',
                prop: 'standardCost',
                sort: true,
                width: 160
            },
            {
                label: '目标价',
                prop: 'targetPrice',
                sort: true,
                width: 160
            },
            {
                label: '成本比例(%)',
                prop: 'costRate',
                sort: true,
                width: 160
            },
            {
                label: '信息费',
                prop: 'infoFee',
                sort: true,
                width: 160
            },
            {
                label: '预付方式',
                prop: 'payMethodName',
                sort: true,
                width: 160
            },
            {
                label: '预付金额',
                prop: 'prepaidAmount',
                sort: true,
                width: 160
            },
            {
                label: '油卡结付金额',
                prop: 'oilcardPayAmount',
                sort: true,
                width: 160
            },
            {
                label: '分公司编码',
                prop: 'companyCode',
                sort: true,
                width: 160
            },
            {
                label: '服务平台',
                prop: 'siteName',
                sort: true,
                width: 160
            },
            {
                label: '是否串点计费',
                prop: 'dmsFlagName',
                sort: true,
                width: 160
            },
            {
                label: '实装净重',
                prop: 'loadedNetWeight',
                sort: true,
                width: 160
            },
            {
                label: '卸货补贴里程',
                prop: 'unloadSubsidyMileage',
                sort: true,
                width: 160
            },
            {
                label: '装货补贴里程',
                prop: 'loadSubsidyMileage',
                sort: true,
                width: 160
            },
            {
                label: '现汇税率',
                prop: 'taxRate',
                sort: true,
                width: 160
            },
            {
                label: '装载类型',
                prop: 'loadTypeName',
                sort: true,
                width: 160
            },
            {
                label: '发车时间',
                prop: 'dispatchTime',
                sort: true,
                width: 160
            },

            {
                label: '离园时间',
                prop: 'leaveDate',
                sort: true,
                width: 160
            },
            {
                label: '备注',
                prop: 'remark',
                sort: true,
                width: 160
            },
            {
                label: '是否可见',
                prop: 'carrierVisibleFlagName',
                sort: true,
                width: 160
            },
            {
                label: '调度人员',
                prop: 'creator',
                sort: true,
                width: 160
            },
            {
                label: '创建时间',
                prop: 'createTime',
                sort: true,
                width: 160
            },

            {
                label: '最后修改人',
                prop: 'updateUserName',
                sort: true,
                width: 160
            },
            {
                label: '最后修改时间',
                prop: 'updateTime',
                sort: true,
                width: 160
            },
            {
                label: '已到车登记数',
                prop: 'arrivalRegistrationSiteNum',
                sort: true,
                width: 160
            },
            {
                label: '已抵达站点数',
                prop: 'arrivalConfirmSiteNum',
                sort: true,
                width: 160
            },
            {
                label: '到车登记方式',
                prop: 'arriveTypeName',
                sort: true,
                width: 160
            },
            {
                label: '是否零担下发',
                prop: 'otpLdFlagName',
                sort: true,
                width: 100
            },
            {
                label: '始发地',
                prop: 'senderDetailAddr',
                sort: true,
                width: 160
            },
            {
                label: '目的地',
                prop: 'receiverDetailAddr',
                sort: true,
                width: 160
            },
            {
                label: '创建人编码',
                prop: 'createUserCode',
                sort: true,
                width: 160
            },
            {
                label: '排队编码',
                prop: 'queueCode',
                sort: true,
                width: 160
            },
            {
                label: '发运类型',
                prop: 'shippingTypeName',
                sort: true,
                width: 160
            },
            {
                label: '审批链接',
                prop: 'iflowLink',
                type: 'button',
                sort: true,
                width: 160
            },
            {
                label: '事业部合同外审批链接',
                prop: 'businessIflowUrl',
                type: 'button',
                sort: true,
                width: 200
            },
            {
                label: '事业部合同外审批状态',
                prop: 'businessIflowStatus',
                type: 'select',
                align: 'center',
                optionNum: 'NEW_TMS_IFLOW_STATUS',
                options: [],
                sort: true,
                width: 200
            },
            {
                label: '零担下发状态',
                prop: 'lclStatusName',
                sort: true,
                width: 160
            },
            {
                label: '下发零担平台',
                prop: 'lclPlate',
                sort: true,
                width: 160
            },
            {
                label: '运输协议签署状态',
                prop: 'transportProtocolStatusName',
                sort: true,
                width: 160
            },
            {
                label: '网络调车单号',
                sort: true,
                prop: 'netDispatchNo',
                width: 140
            },
            {
                label: '运输协议编号',
                prop: 'transportProtocolCode',
                sort: true,
                width: 160
            },
            {
                label: '发车方式',
                prop: 'dispatchWayName',
                sort: true,
                width: 160
            },
            {
                label: '发车位置',
                prop: 'departPosition',
                sort: true,
                width: 160
            },
            {
                label: '线路',
                prop: 'lineName',
                sort: true,
                width: 160
            },
            {
                label: '异常发车原因',
                prop: 'abnormalDepartReasonName',
                sort: true,
                width: 160
            },
            {
                label: '异常发车原因说明',
                prop: 'abnormalDepartReasonRemark',
                sort: true,
                width: 160
            },
            {
                label: '是否发车已计费',
                prop: 'departBmsFlagName',
                sort: true,
                width: 160
            },
            {
                label: '装车完成时间',
                prop: 'ztbLoadDate',
                sort: true,
                width: 160
            },
            {
                label: '专业公司',
                prop: 'professionalCompany',
                sort: true,
                width: 160
            },
            {
                label: '分公司',
                prop: 'companyName',
                sort: true,
                width: 160
            },
            {
                label: '是否退货',
                prop: 'isReject',
                type: 'select',
                options: [
                    { value: '0', label: '否' },
                    { value: '1', label: '是' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '发货省',
                prop: 'senderProvinceName',
                sort: true,
                width: 160
            },
            {
                label: '发货市',
                prop: 'senderCityName',
                sort: true,
                width: 160
            },
            {
                label: '发货区',
                prop: 'senderDistrictName',
                sort: true,
                width: 160
            },
            {
                label: '收货省',
                prop: 'receiverProvinceName',
                sort: true,
                width: 160
            },
            {
                label: '收货市',
                prop: 'receiverCityName',
                sort: true,
                width: 160
            },
            {
                label: '收货区',
                prop: 'receiverDistrictName',
                sort: true,
                width: 160
            },
            {
                label: '额定装载量(m³)',
                prop: 'ratedLoad',
                sort: true,
                width: 160
            },
            {
                label: '满载率',
                prop: 'fullLoadRate',
                sort: true,
                width: 160
            },
            {
                label: '装货点数量',
                prop: 'totalArrivalRegistrationSiteNum',
                sort: true,
                width: 160
            },
            {
                label: 'OCR识别车牌号',
                prop: 'ocrVehicleCard',
                sort: true,
                width: 160
            },
            {
                label: 'NTP成交价',
                prop: 'ntpCost',
                sort: true,
                width: 160
            },
            {
                label: '发车照片',
                prop: 'files',
                type: 'photos',
                sort: true,
                width: 160
            },
            {
                label: '发车照片上传时间',
                prop: 'departPicUploadTime',
                sort: true,
                width: 160
            },
            {
                label: '是否套牌车',
                prop: 'cloneCarFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: 'N', label: '否' },
                    { value: 'Y', label: '是' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '装载率体积(m³)',
                prop: 'loadRateVolume',
                sort: true,
                width: 160
            },
            {
                label: '发车标识',
                prop: 'rearrangeRemark',
                sort: true,
                width: 160
            },
            {
                label: '最终发车时间',
                prop: 'finalDispatchTime',
                sort: true,
                width: 160
            },
            {
                label: '围栏发车时间',
                prop: 'fenceDepartTime',
                sort: true,
                width: 160
            },
            {
                label: '围栏抵达时间',
                prop: 'fenceArrivalTime',
                sort: true,
                width: 160
            },
            {
                label: '抵达登记',
                prop: 'arrivalWay',
                type: 'select',
                optionNum: 'ARRIVER_WAY',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '是否直通宝转运',
                prop: 'ztbTransportFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: '1', label: '是' },
                    { value: '0', label: '否' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '预排车调度类型',
                prop: 'dispatchType',
                type: 'select',
                optionNum: 'TMS_DISPATCH_TYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '包裹数',
                prop: 'sumPackages',
                sort: true,
                width: 160
            },
            {
                label: '配送费',
                prop: 'etdoAllCost',
                sort: true,
                width: 160
            },
            {
                label: '司机接单状态',
                prop: 'driverOrderStatusName',
                type: 'custom',
                sort: true,
                width: 160
            },
            {
                label: '当前预警类型',
                prop: 'currentAlertTypeName',
                type: 'custom',
                sort: true,
                width: 160
            },
            {
                label: '预警等待时长(分)',
                prop: 'estimatedWaitingTime',
                sort: true,
                width: 160
            },
            {
                label: '预警结果',
                prop: 'expectedResultName',
                type: 'custom',
                sort: true,
                width: 160
            },
            {
                label: '司机接单时间',
                prop: 'driverOrderTime',
                sort: true,
                width: 160
            },
            {
                label: '接单司机',
                prop: 'orderDriver',
                sort: true,
                width: 160
            },
            {
                label: '司机信息',
                prop: 'driverInfo',
                sort: true,
                width: 160
            },
            {
                label: '实时位置跟踪',
                prop: 'lastTrackingLocation',
                sort: true,
                width: 160
            },
            {
                label: '最新定位时间',
                prop: 'lastTrackingDate',
                sort: true,
                width: 160
            },
            {
                label: '异常备注',
                prop: 'departExceptionRemarks',
                type: 'select',
                optionNum: 'DISPATCH_ABNORMAL_REASON',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '异常其它信息',
                prop: 'departExceptionInformation',
                sort: true,
                width: 160
            },
            {
                label: '是否直控运力',
                prop: 'directControlCarrierFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: '1', label: '是' },
                    { value: '0', label: '否' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '是否正向',
                prop: 'twoway',
                type: 'select',
                optionNum: '',
                options: [
                    { value: 'Y', label: '是' },
                    { value: 'N', label: '否' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '是否关联订单',
                prop: 'isAssociatedOrder',
                type: 'select',
                optionNum: '',
                options: [
                    { value: 'Y', label: '是' },
                    { value: 'N', label: '否' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '是否直控线路',
                prop: 'directControlLineFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: '1', label: '是' },
                    { value: '0', label: '否' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '是否顺路带回',
                prop: 'conveniently',
                type: 'select',
                optionNum: '',
                options: [
                    { value: '1', label: '是' },
                    { value: '0', label: '否' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '发车人工操作原因',
                prop: 'departOperateReason',
                sort: true,
                width: 160
            },
            {
                label: '围栏到车时间',
                prop: 'fenceArriveTime',
                sort: true,
                width: 160
            },
            {
                label: '预计逾期时间',
                prop: 'besOverdueDate',
                sort: true,
                width: 160
            },
            {
                label: '内外部渠道',
                prop: 'customerAttribute',
                sort: true,
                width: 160
            },
            {
                label: '仓库',
                prop: 'whNames',
                sort: true,
                width: 160
            },
            {
                label: '合同编号',
                prop: 'contractNo',
                sort: true,
                width: 160
            },
            {
                label: '司机编码',
                prop: 'driverNo',
                sort: true,
                width: 160
            },
            {
                label: '在途联系类别',
                prop: 'onWayContactCategory',
                type: 'select',
                optionNum: '',
                options: [
                    { value: '1', label: '司机' },
                    { value: '2', label: '供应商' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '在途联系人',
                prop: 'onWayContactName',
                sort: true,
                width: 160
            },
            {
                label: '在途联系电话',
                prop: 'onWayContactPhone',
                sort: true,
                width: 160
            },
            {
                label: '绑定时间',
                prop: 'deviceNoBoundTime',
                sort: true,
                width: 160
            },
            {
                label: '解绑时间',
                prop: 'deviceNoUnboundTime',
                sort: true,
                width: 160
            },
            {
                label: '卸货站点数',
                prop: 'totalArrivalConfirmSiteNum',
                sort: true,
                width: 160
            },
            {
                label: '运行车线',
                prop: 'runLine',
                sort: true,
                width: 160
            },
            {
                label: '发车照片是否翻拍',
                prop: 'isRemake',
                type: 'select',
                optionNum: 'TMS_IS_REMAKE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '司机自助打印',
                prop: 'isDriverSelfPrint',
                type: 'select',
                optionNum: '',
                options: [
                    { value: 'Y', label: '是' },
                    { value: 'N', label: '否' }
                ],
                width: 120
            },
            {
                label: '司机打印状态',
                prop: 'driverPrintStatusList',
                type: 'select',
                multiple: true,
                optionNum: 'DRIVER_PRINT_STATUS',
                options: [],
                width: 120
            },
            {
                label: '按趟计费标识',
                prop: 'billingRanksFlag',
                type: 'select',
                optionNum: 'BILLING_RANKS_FLAG',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '日计费趟数',
                prop: 'ranksCount',
                sort: true,
                width: 160
            },
            {
                label: '长合车计费新',
                prop: 'mileageBillingType',
                type: 'select',
                optionNum: 'MILEAGE_BILLING_TYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '未下发原因分类',
                prop: 'ztbUnissueReason',
                type: 'select',
                optionNum: 'NOT_ISSUING_REASON',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '返程里程',
                prop: 'backMileage',
                sort: true,
                width: 160
            },
            {
                label: '总包件数',
                prop: 'totalPkgQty',
                sort: true,
                width: 160
            },
            {
                label: '报表打印次数',
                prop: 'allPrintTimes',
                sort: true,
                width: 160
            },
            {
                label: '分拨交接单打印次数',
                prop: 'allocatePrintTimes',
                sort: true,
                width: 160
            },
            {
                label: '集配单打印次数',
                prop: 'collectPrintTimes',
                sort: true,
                width: 160
            },
            {
                label: '提货单打印次数',
                prop: 'deliveryPrintTimes',
                sort: true,
                width: 160
            },
            {
                label: '配送单打印次数',
                prop: 'distributionPrintTimes',
                sort: true,
                width: 160
            },
            {
                label: '出库单打印次数',
                prop: 'outPrintTimes',
                sort: true,
                width: 160
            },
            {
                label: '送货清单打印次数',
                prop: 'shqdPrintTimes',
                sort: true,
                width: 160
            },
            {
                label: '电子面单打印次数',
                prop: 'ysPrintTimes',
                sort: true,
                width: 160
            },
            {
                label: '退货单打印次数',
                prop: 'returnPrintTimes',
                sort: true,
                width: 160
            },
            {
                label: 'KA客户配送单打印次数',
                prop: 'kaCustomerPrintTimes',
                sort: true,
                width: 160
            }
        ],
        action: [
            // {
            //     type: 'text',
            //     label: '到车登记',
            //     size: 'mini',
            //     event: 'arrivalRegistration',
            //     ifHas: '150101001'
            // },
            // {
            //     type: 'text',
            //     label: '取消到车',
            //     size: 'mini',
            //     event: 'cancelArrival',
            //     ifHas: '150101002'
            // },
            // {
            //     type: 'text',
            //     label: '明细装车',
            //     size: 'mini',
            //     event: 'detailedLoading',
            //     ifHas: '150101003'
            // },
            // {
            //     type: 'text',
            //     label: '整单装车',
            //     size: 'mini',
            //     event: 'wholeOrderLoading',
            //     ifHas: '150101004'
            // },
            // {
            //     type: 'text',
            //     label: '发车',
            //     size: 'mini',
            //     event: 'depart',
            //     ifHas: '150101005'
            // },
            // {
            //     type: 'text',
            //     label: '运抵确认',
            //     size: 'mini',
            //     event: 'arrivalConfirmation',
            //     ifHas: '150101006'
            // },
            // {
            //     type: 'text',
            //     label: '取消运抵',
            //     size: 'mini',
            //     event: 'cancelShipTo',
            //     ifHas: '150101007'
            // },
            {
                type: 'text',
                label: '打印',
                size: 'mini',
                event: 'print',
                ifHas: '/performance/dispatch-order/print'
            },
            {
                type: 'text',
                label: '打印日志',
                size: 'mini',
                event: 'printLog',
                ifHas: ''
            },
            // {
            //     type: 'text',
            //     label: '成本校验',
            //     size: 'mini',
            //     event: 'costValidator',
            //     ifHas: '150101009' // 两边共存
            // },
            // {
            //     type: 'text',
            //     label: '成本审批',
            //     size: 'mini',
            //     event: 'costApprove',
            //     ifHas: '150101010'
            // },
            // {
            //     type: 'text',
            //     label: '零担下发',
            //     size: 'mini',
            //     event: 'issue',
            //     ifHas: '150101011'
            // },
            // {
            //     type: 'text',
            //     label: '取消零担下发',
            //     size: 'mini',
            //     event: 'cancelIssue',
            //     ifHas: '150101012'
            // },
            // {
            //     type: 'text',
            //     label: '合同外线路',
            //     size: 'mini',
            //     event: 'contractLine',
            //     ifHas: '150101013' // 两边共存
            // },
            // {
            //     type: 'text',
            //     label: '运输协议',
            //     size: 'mini',
            //     event: 'transportProtocol',
            //     ifHas: '150101014'
            // },
            // {
            //     type: 'text',
            //     label: '成本校验-按车计费',
            //     size: 'mini',
            //     event: 'costValidatorByCar',
            //     ifHas: '/performance/dispatch-order/costValidatorByCar' // 两边共存
            // },
            // {
            //     type: 'text',
            //     label: '发车单设备',
            //     size: 'mini',
            //     event: 'dispatchDevice',
            //     ifHas: '150101015'
            // },
            // {
            //     type: 'text',
            //     label: '任务设备',
            //     size: 'mini',
            //     event: 'taskDevice',
            //     ifHas: '150101054'
            // },
            {
                type: 'text',
                label: '园区预约',
                size: 'mini',
                event: 'parkAppoint',
                ifHas: '/performance/dispatch-order/parkAppoint'
            }
            // {
            //     type: 'text',
            //     label: '在途登记',
            //     size: 'mini',
            //     event: 'onTheWay',
            //     ifHas: '150101017'
            // },
            // {
            //     type: 'text',
            //     label: '位置信息查看',
            //     size: 'mini',
            //     event: 'viewLocationInformation',
            //     ifHas: '150101018'
            // },
            // {
            //     type: 'text',
            //     label: '装车顺序',
            //     size: 'mini',
            //     event: 'sequence',
            //     ifHas: '150101035'
            // },
            // {
            //     type: 'text',
            //     label: '查看轨迹',
            //     size: 'mini',
            //     event: 'viewTrack',
            //     ifHas: '150101037'
            // },
            // {
            //     type: 'text',
            //     label: '整车异常发车原因',
            //     size: 'mini',
            //     event: 'abnormalReason',
            //     ifHas: '150101039'
            // },
            // {
            //     type: 'text',
            //     label: '编辑运输成本',
            //     size: 'mini',
            //     event: 'editTransportationCost',
            //     ifHas: '150101038'
            // },
            // {
            //     type: 'text',
            //     label: '在途编辑',
            //     size: 'mini',
            //     event: 'inTransitEdit',
            //     ifHas: '150101050'
            // },
            // {
            //     type: 'text',
            //     label: '取消装货',
            //     size: 'mini',
            //     event: 'cancelLoading',
            //     ifHas: '150101048'
            // },
            // {
            //     type: 'text',
            //     label: '车辆改派记录',
            //     size: 'mini',
            //     event: 'vehicleRecord',
            //     ifHas: '150101043'
            // }
        ],
        leftOperation: true,
        leftWidth: 200
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 100,
        pageSizes: [10, 20, 30, 50, 100]
    },
    searchTotalTitle: [
        {
            name: '发车时间',
            value: 'dispatchTime',
            startTime: 'startDispatchTime',
            endTime: 'endDispatchTime',
            type: 'time'
        },
        {
            name: '离园时间',
            value: 'leaveDate',
            type: 'time',
            startPlaceholder: '离园起始时间',
            endPlaceholder: '离园结束时间'
        },
        {
            name: '抵达时间',
            value: 'arrivalTime',
            type: 'time',
            startPlaceholder: '抵达起始时间',
            endPlaceholder: '抵达结束时间'
        },
        {
            name: '是否打印单据',
            value: 'isPrintAssembly',
            type: 'select',
            optionNum: 'YES_OR_NO'
        },
        {
            name: '运输协议签署状态',
            value: 'transportProtocolStatus',
            type: 'select',
            optionNum: 'TP_DISPATCH_STATUS',
            options: []
        },
        {
            name: '未下发原因分类',
            value: 'ztbUnissueReason',
            type: 'select',
            multiple: true,
            optionNum: 'NOT_ISSUING_REASON',
            options: []
        },
        {
            name: '高端服务发车单',
            value: 'emergencyFlagList',
            type: 'select',
            multiple: true,
            filterable: true,
            optionNum: 'DISPATCH_EMERGENCE_FLAG',
            options: []
        },
        {
            name: '合同外场景',
            value: 'contractOutList',
            type: 'select',
            filterable: true,
            multiple: true,
            optionNum: 'TMS_CONTRACT_SITUATION',
            options: []
        },
        {
            name: '审批状态',
            value: 'iflowStatusList',
            type: 'select',
            filterable: true,
            multiple: true,
            optionNum: '',
            options: [
                { value: 'R', label: '审批中' },
                { value: 'P', label: '审批通过' }
            ]
        },
        {
            name: '是否发起审批',
            value: 'isIflow',
            type: 'select',
            filterable: true,
            optionNum: '',
            options: [
                { value: 'true', label: '是' },
                { value: 'false', label: '否' }
            ]
        },
        {
            name: '是否中台计费前置',
            value: 'billingAdvanceFlag',
            type: 'select',
            filterable: true,
            optionNum: '',
            options: [
                { value: 'true', label: '是' },
                { value: 'false', label: '否' }
            ]
        },
        {
            name: '是否计费异常',
            value: 'billingExceptionFlag',
            type: 'select',
            filterable: true,
            optionNum: '',
            options: [
                { value: 'true', label: '是' },
                { value: 'false', label: '否' }
            ]
        },
        {
            name: '是否中台试算',
            value: 'trialCalculateFlag',
            type: 'select',
            filterable: true,
            optionNum: '',
            options: [
                { value: 'true', label: '是' },
                { value: 'false', label: '否' }
            ]
        },
        {
            name: '中台计费类型',
            value: 'billingAdvanceType',
            type: 'select',
            filterable: true,
            optionNum: '',
            options: [
                { value: 'AP', label: '中台收入计费' },
                { value: 'AR', label: '中台成本计费' },
                { value: 'ARP', label: '中台收入+成本计费' },
                { value: 'B', label: 'BMS计费' },
                { value: 'M', label: '费用录入' }
            ]
        },
        {
            name: '中台计费状态',
            value: 'billingAdvanceStatus',
            type: 'select',
            filterable: true,
            optionNum: '',
            options: [
                { value: 'success', label: '中台计费成功' },
                { value: 'failed', label: '中台计费失败' }
            ]
        },
        {
            name: '是否正向',
            value: 'twoway',
            type: 'select',
            options: [
                { value: 'Y', label: '是' },
                { value: 'N', label: '否' }
            ]
        },
        {
            name: '设备类型',
            value: 'deviceTypeList',
            type: 'select',
            multiple: true,
            optionNum: 'DEVICETYPE'
        },
        {
            name: '服务平台',
            advanceLabel: '服务平台',
            value: 'siteName',
            multiple: true,
            maxSelect: 5,
            border: true,
            dialogWidth: '800px',
            multipleTableColumn: {
                prop: 'escoCompanyNameCn', 'value': '服务平台名称'
            },
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' }
            ],
            method: 'post',
            prefix: '/api-tms',
            advanceUrl: '/user/auth/data/site/query',
            type: 'advance',
            cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName']
        },
        {
            name: '分公司',
            advanceLabel: '分公司',
            value: 'companyName',
            multiple: true,
            border: true,
            dialogWidth: '800px',
            multipleTableColumn: {
                prop: 'escoCompanyNameCn', 'value': '分公司名称'
            },
            advanceConfig: [
                { prop: 'escoCompanyNameCn', 'value': '分公司名称' },
                { prop: 'escoCompanyNo', 'value': '分公司编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNo', 'value': '分公司编码' },
                { prop: 'escoCompanyNameCn', 'value': '分公司名称' }
            ],
            advanceUrl: '/searchBrand',
            type: 'advance',
            cbParams: ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode']
        },
        {
            name: '调度人员',
            value: 'createUserNameDispatch',
            type: 'input',
            fieldTrim: true,
            placeholder: '多个调度员中间用空格或英文逗号符隔开'
        },
        {
            name: '排队编码',
            value: 'queueCode',
            type: 'input'
        },
        {
            name: '仓库',
            value: 'whName',
            unfold: true,
            multiple: true,
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'cdwhName', value: '仓库名称'
            },
            advanceConfig: [
                { prop: 'cdwhName', value: '仓库名称' },
                { prop: 'whCode', value: '仓库编码' }
            ],
            tableConfig: [
                { prop: 'whCode', value: '仓库编码' },
                { prop: 'cdwhName', value: '仓库名称' }
            ],
            advanceUrl: 'cdWarehouse/search?cdwhIsStop=0',
            cbParams: ['whCode', 'cdwhName#whName'],
            type: 'advance',
            advanceCode: 'cdwhName'
        },
        {
            name: '客户',
            value: 'customerName',
            type: 'advance',
            unfold: true,
            multiple: true,
            border: true,
            dialogWidth: '800px',
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'ebcuNameCn', 'value': '客户名称'
            },
            advanceConfig: [
                { prop: 'ebcuNameCn', value: '客户名称' },
                { prop: 'pmCode', value: '客户编码' }
            ],
            tableConfig: [
                { prop: 'pmCode', value: '客户编码' },
                { prop: 'ebcuNameCn', value: '客户名称' }
            ],
            advanceUrl: '/ebCustomer/searchByEbCustomer',
            cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName'],
            advanceCode: 'advanceCode'
        },
        // {
        //     name: '承运商',
        //     advanceLabel: '承运商',
        //     value: 'carrierName',
        //     multiple: true,
        //     maxSelect: 5,
        //     multipleTableColumn: {
        //         prop: 'supplierNameCn', 'value': '承运商名称'
        //     },
        //     advanceConfig: [
        //         { prop: 'supplierNameCn', value: '承运商名称' },
        //         { prop: 'supplierCode', value: '承运商编码' }
        //     ],
        //     tableConfig: [
        //         { prop: 'supplierNameCn', value: '承运商名称' },
        //         { prop: 'supplierCode', value: '承运商编码' },
        //         { prop: 'transNameListStr', value: '采购渠道' }
        //     ],
        //     method: 'post',
        //     prefix: '/api-tms',
        //     advanceUrl: '/srm/supplier/search',
        //     type: 'advance',
        //     advanceNotSearch: true,
        //     queryConditionRequired: true,
        //     cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode', 'transTypeListStr#transType', 'transNameListStr#tranName'],
        //     advanceCascade: 'supplierCode#carrierCode'
        // },
        {
            name: '采购渠道',
            value: 'procurementChannel',
            optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL',
            filterable: true,
            multiple: true,
            options: [],
            type: 'select'
        },
        {
            name: '无车平台类型',
            value: 'noCarCarrierTypeList',
            type: 'select',
            multiple: true,
            filterable: true,
            optionNum: 'NO_CAR_CARRIER_TYPE'
        },
        {
            name: '无车承运商',
            advanceLabel: '无车承运商',
            value: 'noCarCarrierName',
            multiple: true,
            border: true,
            dialogWidth: '800px',
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'supplierNameCn', 'value': '无车承运商名称'
            },
            advanceConfig: [
                { prop: 'supplierNameCn', value: '无车承运商名称' },
                { prop: 'supplierCode', value: '无车承运商编码' }
            ],
            tableConfig: [
                { prop: 'supplierNameCn', value: '无车承运商名称' },
                { prop: 'supplierCode', value: '无车承运商编码' },
                { prop: 'transNameListStr', value: '采购渠道' }
            ],
            method: 'post',
            prefix: '/api-tms',
            advanceUrl: '/srm/supplier/search',
            type: 'advance',
            advanceNotSearch: true,
            queryConditionRequired: true,
            cbParams: ['supplierNameCn#noCarCarrierName', 'supplierCode#noCarCarrierCode']
        },
        {
            name: '车牌号',
            advanceLabel: '车牌号',
            value: 'vehicleCard',
            multiple: true,
            border: true,
            dialogWidth: '800px',
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'licensePlateNumber', 'value': '车牌'
            },
            advanceConfig: [
                { prop: 'licensePlateNumber', value: '车牌' },
                { prop: 'cargoVolumeStr', value: '载货体积' },
                { prop: 'cdegNameCn', value: '车型' }
            ],
            tableConfig: [
                { prop: 'licensePlateNumber', value: '车牌' },
                { prop: 'cargoVolume', value: '载货体积' },
                { prop: 'cdegNameCn', value: '车型' }
            ],
            advanceUrl: 'suCar/searchByConditions',
            type: 'advance',
            cbParams: ['licensePlateNumber#vehicleCard'],
            advanceCascade: 'carrierCode#suppliersCode'
        },
        {
            name: '是否下发',
            value: 'carrierVisibleFlag',
            type: 'select',
            options: [
                { value: 'Y', label: '是' },
                { value: 'N', label: '否' }
            ]
        },
        {
            name: '出入库类型',
            value: 'inOutTypeList',
            type: 'select',
            multiple: true,
            optionNum: 'OTP_IN_OUT_TYPE'
        },
        {
            name: '司机',
            type: 'advance',
            value: 'driver',
            multiple: true,
            border: true,
            dialogWidth: '800px',
            maxSelect: 5,
            multipleTableColumn: {
                prop: 'name', 'value': '司机名称'
            },
            advanceConfig: [
                { 'prop': 'name', 'value': '司机名称' },
                { 'prop': 'encuMobile', 'value': '司机电话' }
            ],
            tableConfig: [
                { 'prop': 'name', 'value': '司机名称' },
                { 'prop': 'encuMobile', 'value': '司机电话' }
            ],
            advanceUrl: 'suDriver/searchByConditions',
            cbParams: [
                'name#driver', 'encuMobile#driverContactWay'
            ]
        },
        {
            name: '发运类型',
            value: 'shippingTypeList',
            type: 'select',
            multiple: true,
            optionNum: 'TMS_SHIPPING_TYPE'
        },
        {
            name: '是否发车已计费',
            value: 'departBmsFlag',
            type: 'select',
            optionNum: '',
            options: [
                { value: 'Y', label: '是' },
                { value: 'N', label: '否' }
            ]
        },
        {
            name: '是否串点计费',
            value: 'dmsFlag',
            type: 'select',
            filterable: true,
            optionNum: 'YES_OR_NO'
        },
        {
            name: '是否套牌车',
            value: 'cloneCarFlag',
            type: 'select',
            optionNum: '',
            options: [
                { value: 'N', label: '否' },
                { value: 'Y', label: '是' }
            ]
        },
        {
            name: '发车照片上传时间',
            value: 'departPicUploadTime',
            startTime: 'departPicUploadTimeStart',
            endTime: 'departPicUploadTimeEnd',
            startPlaceholder: '上传开始日期',
            endPlaceholder: '上传结束日期',
            type: 'time'
        },
        {
            name: '司机接单状态',
            value: 'driverOrderStatus',
            type: 'select',
            optionNum: 'DRIVER_ORDER_STATUS',
            options: []
        },
        {
            name: '司机接单时间',
            value: 'driverOrderTime',
            startTime: 'driverOrderTimeStart',
            endTime: 'driverOrderTimeEnd',
            startPlaceholder: '接单开始日期',
            endPlaceholder: '接单结束日期',
            type: 'time'
        },
        {
            name: '当前预警类型',
            value: 'currentAlertTypeList',
            multiple: true,
            type: 'select',
            optionNum: 'CURRENT_ALERT_TYPE',
            options: []
        },
        {
            name: '装货预约加急',
            value: 'urgentStatus',
            type: 'select',
            optionNum: '',
            options: [
                { label: '是', value: '1' },
                { label: '否', value: '0' }
            ]
        },
        {
            name: '是否直控运力',
            value: 'directControlCarrierFlag',
            type: 'select',
            optionNum: '',
            options: [
                { value: '1', label: '是' },
                { value: '0', label: '否' }
            ]
        },
        {
            name: '是否直控线路',
            value: 'directControlLineFlag',
            type: 'select',
            optionNum: '',
            options: [
                { value: '1', label: '是' },
                { value: '0', label: '否' }
            ]
        },
        {
            name: '是否顺路带回',
            value: 'conveniently',
            type: 'select',
            optionNum: '',
            options: [
                { value: '1', label: '是' },
                { value: '0', label: '否' }
            ]
        },
        {
            name: '设备号',
            value: 'deviceNo',
            type: 'input'
        },
        {
            name: '发货城市',
            value: 'senderAddress',
            type: 'addressCascader',
            minLayers: 3,
            span: 4
        },
        {
            name: '收货城市',
            value: 'receiverAddress',
            type: 'addressCascader',
            minLayers: 3,
            span: 4
        },
        {
            name: '专业公司',
            value: 'professionalCompanyList',
            type: 'select',
            multiple: true,
            options: [],
            optionNum: 'JD_PROFESSIONAL_COMPANY'
        },
        {
            name: '预排车调度类型',
            value: 'dispatchTypeList',
            type: 'select',
            multiple: true,
            optionNum: 'TMS_DISPATCH_TYPE',
            options: []
        },
        {
            name: '发车单照片是否翻拍',
            value: 'isRemake',
            type: 'select',
            optionNum: 'TMS_IS_REMAKE',
            options: []
        },
        {
            name: '按趟计费标识',
            value: 'billingRanksFlag',
            type: 'select',
            optionNum: 'BILLING_RANKS_FLAG',
            options: []
        },
        {
            name: '长合车计费新',
            value: 'mileageBillingType',
            type: 'select',
            optionNum: 'MILEAGE_BILLING_TYPE',
            options: []
        },
        {
            name: '司机自助打印',
            value: 'isDriverSelfPrint',
            type: 'select',
            optionNum: '',
            options: [
                { value: 'Y', label: '是' },
                { value: 'N', label: '否' }
            ]
        },
        {
            name: '司机打印状态',
            value: 'driverPrintStatusList',
            type: 'select',
            optionNum: 'DRIVER_PRINT_STATUS',
            options: [],
            multiple: true
        },
        {
            name: '是否退货',
            value: 'isReject',
            type: 'select',
            options: [
                { value: '0', label: '否' },
                { value: '1', label: '是' }
            ]
        }
    ]
};

export const importConfig = {
    ImportConfig: {
        action: `${process.env.VUE_APP_API_URL || ''}/api-antms/transport/dispatch/saveOnWayPositionTrace/expressImportCheck`,
        multiple: true,
        ImportTitle: '导入', // 弹窗title，不传默认为 导入
        accept: '.xlsx', // 筛选文件
        showFileList: true,
        fileType: '只能上传Excel文件,一次导入数据不能超过1000条',
        manualUpload: false // 手动上传
    },
    ImportContent: [
        {
            'fileName': '发车单在途登记批量导入模板.xlsx',
            'fileSize': '14.6KB',
            'downLoadInfo': {
                'url': ''
            }
        }
    ]
};

export const operation = [
    // {
    //     type: 'text',
    //     label: '特权下发直通宝',
    //     size: 'mini',
    //     event: 'grantingPrivileges',
    //     ifHas: '150101001'
    // },
    // {
    //     type: 'text',
    //     label: '成本异常查看',
    //     size: 'mini',
    //     event: 'costAnomaly',
    //     ifHas: '150101002'
    // },
    // {
    //     type: 'text',
    //     label: '成本校验',
    //     size: 'mini',
    //     event: 'costValidator',
    //     ifHas: '150101009' // 两边共存
    // },
    // {
    //     type: 'text',
    //     label: '成本校验-按车计费',
    //     size: 'mini',
    //     event: 'costValidatorByCar',
    //     ifHas: '/performance/dispatch-order/costValidatorByCar' // 两边共存
    // },
    // {
    //     type: 'text',
    //     label: '成本试算',
    //     size: 'mini',
    //     event: 'billingTrial',
    //     ifHas: '150101004'
    // },
    // {
    //     type: 'text',
    //     label: '发车单编辑',
    //     size: 'mini',
    //     event: 'dispatchEdit',
    //     ifHas: '150101005'
    // },
    // {
    //     type: 'text',
    //     label: '合同外线路',
    //     size: 'mini',
    //     event: 'contractLine',
    //     ifHas: '150101013' // 两边共存
    // }
];

export const hideField = {
    'transportIncome': '运输收入(元)',
    'grossProfitMargin': '毛利率',
    'grossProfit': '毛利金额',
    'bmsIncomeAfter': '目标价-以收定支'
};
